import React from "react";
import { connect } from "react-redux";
import i18n from "i18next";

import FooterItem from "@/react-components/FooterItem";
import { routerEnum, modeEnum } from "@/utils/enum";
import config from "@/utils/config";
import { preventClickEvent } from "@/utils";

class Footer extends React.Component {
  componentDidMount() {
    this.disableEvent();
  }

  // ee mode disable click event
  disableEvent = () => {
    const { mode } = this.props;
    if (mode === modeEnum.pageEditing || mode === modeEnum.preview) {
      preventClickEvent("footer");
    }
  };

  render() {
    const router = config.router();
    return (
      <footer id="footer" className="footer-container">
        <div className="flex-row footer-container-link">
          {router
            .filter(
              (item) =>
                item.type === routerEnum.footer && !item.notAuthentication
            )
            .map((item, index) => (
              <FooterItem key={index} item={item} />
            ))}
        </div>
        <div
          className="footer-container-explain"
          dangerouslySetInnerHTML={{
            __html: i18n.t("TCMS01002_explain"),
          }}
        />
        <div className="footer-container-copyright">
          COPYRIGHT © NOMURA SECURITIES CO., LTD. ALL RIGHTS RESERVED
        </div>
      </footer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    state: state?.user?.authState,
    mode: state?.config?.mode,
  };
};

export default connect(mapStateToProps)(Footer);
